<!-- Dialog for deleting elevation table record(s) -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <h1>Delete {{lakeBasinID.length}} Elevation(s)?</h1>

        <!-- Lake Basin ID -->
        <div>
            <mat-form-field style="width:75%;color:darkgrey;font-style:italic;">
                <mat-label>Lake Basin ID(s)</mat-label>
                <input matInput [(ngModel)]="lakeBasinID" readonly tabindex="-1">
            </mat-form-field>
        </div>

</mat-dialog-content>

<!-- Buttons -->
<mat-dialog-actions align="end">
    <!-- Delete study button -->
    <button mat-raised-button color="warn" (click)="deleteElevation()" mat-dialog-close>Delete</button>
    <!-- Close button -->
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
